<template>
  <div :class="[prefixCls, stepIconClasses]">
    <SVGIconNext v-if="doingIndex > index" icon="web-icon/icon_line_selected/1" :axes="{ stroke: 1.25 }" :size="16" :palette="props.huahuoPlus ? ['#FF5500'] : ['#FF6699']" />

    <span v-else :class="[prefixCls + '__num', stepIconClasses]">{{ index }}</span>
  </div>
</template>
<script setup lang="ts">
import { SVGIconNext } from '@bilibili/svg-icon-next-vue'
import { computed } from 'vue'
const props = withDefaults(
  defineProps<{
    doingIndex?: number
    index?: number
    huahuoPlus?: boolean
  }>(),
  {
    doingIndex: 0,
    index: 0,
    huahuoPlus: true
  }
)
const prefixCls = 'business-steps-icon'
const stepIconClasses = computed(() => ({
  doing: props.doingIndex === props.index,
  'to-do': props.doingIndex < props.index,
  done: props.doingIndex > props.index,
  'huahuo-plus': props.huahuoPlus
}))
</script>
<style scoped lang="less">
.business-steps-icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
  margin: 0px 8px;
  &.doing {
    background-color: #ff6699;
  }
  &.done {
    border: 1px solid #ff6699;
    background-color: #fff2f6;
  }
  &.to-do {
    background-color: rgba(227, 229, 231, 0.5);
  }
  &.huahuo-plus {
    &.doing {
      background-color: #ff5500;
    }
    &.done {
      border: 1px solid #ff5500;
      background-color: #fff2d7;
    }
  }

  &__num {
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    &.doing,
    &.done {
      font-family: 'number-font-bold';
      font-weight: 500;
      color: #ffffff;
    }
    &.to-do {
      color: rgba(24, 25, 28, 0.7);
    }
  }
}
</style>
